module.exports = __webpack_public_path__ + "static/media/otb-logo.d2df8139.png";